import React from 'react';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';

import { AppCrushModal } from 'shared';

import styles from './PageWrapper.module.scss';

const PageWrapper = () => (
  <div className={styles.container}>
    <ErrorBoundary FallbackComponent={AppCrushModal}>
      <Outlet />
    </ErrorBoundary>
  </div>
);

export default PageWrapper;
